interface ICardTransactionDetailsItemProps {
  label: string;
  value: string | number;
}

export function CardTransactionDetailsItem({ label, value }: ICardTransactionDetailsItemProps) {
  return (
    <div className="flex items-start gap-4">
      <span className="typo-body-light-paragraph text-secondary font-light">{label}</span>
      <span className="typo-body-regular-paragraph text-secondary">{value}</span>
    </div>
  );
}
